import { P2 } from '~/src/geometry/point';
import { comp , constant } from '~/src/base/Function';

import State from '../State';
import * as St from '../State';


export interface Zoom {
	tag : 'Zoom';
	set : boolean;
	val : number;
	pnt : P2;
}

export const zoom = ( val : number , pnt : P2 , set ?: boolean ) : Zoom =>
	( { tag : 'Zoom' , set : set ?? false , val , pnt } );

export const exeZoom = ( state : State , cmd : Zoom ) : State => {
	if ( Math.abs( cmd.val ) < 0.1 || Math.abs( cmd.val ) > 5 )
		return state;

	return comp(
		St.ctrd( constant( false ) ),
		St.zoom( z => z * cmd.val ),
	)( state );
};
